import Vue from 'vue';
import ToastTemp from './Toast.vue';
import MessageBoxTemp from './MessageBox.vue'

const MessageBoxConstructor = Vue.extend(MessageBoxTemp)
const ToastConstructor = Vue.extend(ToastTemp);
let MessageBoxInstance
let ToastInstance

function initToastInstance () {
    ToastInstance = new ToastConstructor({
        el: document.createElement('div')
    })
    document.body.appendChild(ToastInstance.$el);
}

function initMessageBoxInstance () {
    MessageBoxInstance = new MessageBoxConstructor({
        el: document.createElement('div')
    })
    document.body.appendChild(MessageBoxInstance.$el);
}


const MessageBox = function (options) {}

MessageBox.$confirm = (opt, confirmCallback, cancelCallback) => {
    if (!MessageBoxInstance) {
        initMessageBoxInstance();
    }
    MessageBoxInstance.title = opt.title
    MessageBoxInstance.confirmTxt = opt.confirmTxt
    MessageBoxInstance.confirmCallback = confirmCallback
    MessageBoxInstance.cancelCallback = cancelCallback
    Vue.nextTick(() => {
        MessageBoxInstance.show();
    })
}

MessageBox.$toast = (opt, callback) => {
    if (!ToastInstance) {
        initToastInstance();
    }
    let timeout = opt.timeout || 1000
    ToastInstance.title = opt.title
    ToastInstance.top = opt.top || '50%'
    Vue.nextTick(() => {
        ToastInstance.show();
    });
    (ToastInstance.timer) && (clearTimeout(ToastInstance.timer))
    ToastInstance.timer = setTimeout(() => {
        ToastInstance.hide()
        typeof callback === 'function' && callback()
    }, timeout);
}

export { MessageBox }


